import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getI18nByApp } from '../../services/i18n/selector';

import { formatAmountCurrency } from '../../utils';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';

import LinkButtonComponent from '../button/LinkButtonComponent';

import { ErrorEbonModalContainer } from './ErrorEbonModalStyle';

const FunnelPaymentSelectionStep = ({
    modalData,
    merchantCardPath,
    partnerName,
    i18n,
    i18nMulti
}) => {
    return (
        <ErrorEbonModalContainer>
            <h1>{getI18nByApp(i18nMulti, 'page.EBON.MODALDATA.TITLE')}</h1>

            <p className="recapText">{getI18nByApp(i18nMulti, 'page.EBON.MODALDATA.TEXT_1')}</p>

            <div className="wrapper">
                <h3>{`${i18n.RECAPITULATIF}`}</h3>

                {modalData.map((ebons, id) => (
                    <div key={id} className="recapUnavailable">
                        <p>
                            {convertHtmlToReactDomWithParams(
                                getI18nByApp(i18nMulti, 'page.EBON.BON_ACHAT_LIGNE'),
                                partnerName,
                                formatAmountCurrency(ebons.facialValue)
                            )}
                        </p>
                        <div style={{ minWidth: '100px' }}>
                            <span>
                                {ebons.quantityLocked}/{ebons.quantityQuery}{' '}
                            </span>
                            <span>{getI18nByApp(i18nMulti, 'page.EBON.MODALDATA.TEXT_2')}</span>
                            <span style={{ justifyContent: 'flex-end', flex: 2 }}>
                                {formatAmountCurrency(ebons.quantityLocked * ebons.facialValue)}
                            </span>
                        </div>
                    </div>
                ))}

                <LinkButtonComponent
                    to={merchantCardPath}
                    color="main"
                    title={getI18nByApp(i18nMulti, 'page.EBON.MODALDATA.BUTTON')}
                    text={getI18nByApp(i18nMulti, 'page.EBON.MODALDATA.BUTTON')}
                />
            </div>
        </ErrorEbonModalContainer>
    );
};

FunnelPaymentSelectionStep.propTypes = {
    modalData: PropTypes.object,
    merchantCardPath: PropTypes.string,
    partnerName: PropTypes.string
};

const mapStateToProps = (state, ownProps) => {
    return {
        i18n: state.i18n.page.EBON,
        i18nMulti: state.i18n
    };
};

export default connect(mapStateToProps)(FunnelPaymentSelectionStep);



// WEBPACK FOOTER //
// ./src/components/funnel/EbonErrorModal.js